import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { Menu, MenuProps } from "primereact/menu"
import { SyntheticEvent, useRef } from "react"
import { ButtonMenuModel, ButtonMenuModelProps } from "./ButtonMenuModel"

interface ButtonMenuProps {
  buttonProps: React.DetailedHTMLProps<
    React.ButtonHTMLAttributes<HTMLButtonElement>,
    HTMLButtonElement
  >
  onClickButton?: React.MouseEventHandler<HTMLButtonElement>
  menuProps?: MenuProps
  items: ButtonMenuModelProps[]
}

export const ButtonMenu = ({
  buttonProps,
  onClickButton,
  menuProps,
  items,
}: ButtonMenuProps) => {
  const refMenu = useRef<Menu>(null)
  const toggleMenu = (e: SyntheticEvent<Element, Event>) => {
    refMenu?.current?.toggle(e)
  }

  return (
    <>
      <div className='tw-flex tw-cursor-pointer tw-gap-px tw-h-10 tw-text-sm'>
        <button
          type='button'
          className='hover:tw-bg-secondary-over tw-rounded-l-md !tw-bg-secondary tw-p-2 tw-px-4 tw-font-normal tw-text-white tw-transition-colors tw-duration-100 tw-ease-in-out'
          onClick={(e) => onClickButton?.(e)}
          {...buttonProps}
        />
        <Menu
          popup
          ref={refMenu}
          id='button-menu.control'
          className='!tw-w-fit !tw-py-1'
          model={ButtonMenuModel(
            items?.flatMap((item) => ({
              ...item,
              onClick: (e) => {
                item?.onClick?.(e)
                toggleMenu(e)
              },
            }))
          )}
          {...menuProps}
        />
        <div
          className='tw-items-center tw-rounded-r-md tw-bg-secondary'
          onClick={(event) => refMenu?.current?.toggle(event)}
          aria-controls='button-menu.control'
          aria-haspopup
        >
          <FontAwesomeIcon
            icon={["fal", "angle-down"]}
            className='tw-h-5 tw-w-5 tw-px-2 tw-pt-2.5 tw-text-white tw-transition-transform tw-duration-100'
            aria-controls='button-menu.control'
            aria-haspopup
          />
        </div>
      </div>
    </>
  )
}
